var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DataCache } from '../../DataCache';
import { Quantity } from '@shared/commons/UtilsClasses/Quantity';
import { PlacedFrom } from '@shared/utils/Trading/PlacedFrom';
import { TvPositionConvertor } from '../Convertors/TvPositionConvertor';
import { PositionFormatter } from '../../cache/Formatters/PositionFormatter';
import { TvAccountHelper } from '../Helpers/TvAccountHelper';
export class TvPositionsManager {
    constructor(host) {
        this.host = host;
        this.subscribe();
    }
    getPositions() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, reject) => {
                const rPositions = DataCache.Trading.getPositionsByAccount(TvAccountHelper.getCurrentAccount());
                const positions = [];
                for (const position of rPositions) {
                    const tvPosition = TvPositionConvertor.convertToTvPosition(position);
                    positions.push(tvPosition);
                }
                resolve(positions);
            });
        });
    }
    closePosition(positionId, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            yield new Promise((resolve, reject) => {
                const position = DataCache.Trading.getPositionById(positionId);
                if (!position) {
                    reject(`Position with id ${positionId} not found`);
                    return;
                }
                const amountToClose = amount !== null && amount !== void 0 ? amount : position.Amount;
                const qty = new Quantity(amountToClose, true);
                DataCache.FOrderExecutor.closePositionQuantity(position, qty, null, PlacedFrom.TV_TRADING_PLATFORM_OTHER);
                resolve();
            });
        });
    }
    updatePositions() {
        const rPositions = DataCache.Trading.getPositionsByAccount(TvAccountHelper.getCurrentAccount());
        for (const position of rPositions) {
            // TODO: кэшировать ласт прайс?
            // И апдейтить только если ласт прайс обновился?
            if (position.lastPriceUpdated) {
                const pnl = position.Account.roundPrice(position.getGrossPnL(true));
                this.host.plUpdate(position.PositionId, pnl);
                const tvPosition = TvPositionConvertor.convertToTvPosition(position);
                tvPosition.last = position.CurPriceClose;
                tvPosition.pl = pnl; // position.Account.formatPrice(pnl);
                tvPosition.netpl = PositionFormatter.NetPnL(position, true);
                tvPosition.swaps = position.GetSwaps(true);
                tvPosition.fee = PositionFormatter.Commission(position, true);
                const sl = PositionFormatter.StopLossPrice(position);
                if (!isNaN(sl)) {
                    tvPosition.stopLoss = sl;
                }
                else {
                    tvPosition.stopLoss = undefined;
                }
                const tp = PositionFormatter.TakeProfitPrice(position);
                if (!isNaN(tp)) {
                    tvPosition.takeProfit = tp;
                }
                else {
                    tvPosition.takeProfit = undefined;
                }
                this.host.positionPartialUpdate(position.PositionId, tvPosition);
            }
        }
    }
    subscribe() {
        DataCache.OnAddPosition.Subscribe(this.onAddOrUpdatePosition, this);
        DataCache.OnUpdatePosition.Subscribe(this.onAddOrUpdatePosition, this);
        DataCache.OnRemovePosition.Subscribe(this.onRemovePosition, this);
        // CorporateAction
        DataCache.OnAddCorporateAction.Subscribe(this.onAddOrUpdatePosition, this);
        DataCache.OnUpdateCorporateAction.Subscribe(this.onAddOrUpdatePosition, this);
        DataCache.OnRemoveCorporateAction.Subscribe(this.onRemovePosition, this);
    }
    unsubscribe() {
        DataCache.OnAddPosition.UnSubscribe(this.onAddOrUpdatePosition, this);
        DataCache.OnUpdatePosition.UnSubscribe(this.onAddOrUpdatePosition, this);
        DataCache.OnRemovePosition.UnSubscribe(this.onRemovePosition, this);
        // CorporateAction
        DataCache.OnAddCorporateAction.UnSubscribe(this.onAddOrUpdatePosition, this);
        DataCache.OnUpdateCorporateAction.UnSubscribe(this.onAddOrUpdatePosition, this);
        DataCache.OnRemoveCorporateAction.UnSubscribe(this.onRemovePosition, this);
    }
    onAddOrUpdatePosition(position) {
        if (position.Account !== TvAccountHelper.getCurrentAccount())
            return;
        const tvPosition = TvPositionConvertor.convertToTvPosition(position);
        this.host.positionUpdate(tvPosition);
    }
    onRemovePosition(position) {
        if (position.Account !== TvAccountHelper.getCurrentAccount())
            return;
        const tvPosition = TvPositionConvertor.convertToTvPosition(position);
        tvPosition.qty = 0; // признак удаления позиции
        this.host.positionUpdate(tvPosition);
    }
    // #region IDestroyable
    destroy() {
        this.unsubscribe();
    }
}
